import { createReportService, IReportService } from './report_services';
import { createCommonDateServices, ICommonDateServices } from 'services/commonDate_services';
import { createTestTargetServices, ITestTargetServices } from './testTarget_services';
import { createUserServices, IUserServices } from './user_services';
import { createRoutingServices, IRoutingServices } from './routing_services';
import { createWorkOrderServices, IWorkOrderServices } from './workOrder_services';
import { createProductServices, IProductServices } from './product_services';
import { createListCategoryServices, IListCategoryServices } from './listCategory_services';
import { createProductRoutingServices, IProductRoutingServices } from './productRouting_services';
import { createMCCommandServices, IMCCommandServices } from './matchCardCommand_services';
import { createHistoryRecieveServices, IHistoryReceiveServices } from './historyReceive_sevieces';
import { createReportSavedServices, IReportSavedServices } from './reportSaved_servieces';
import { createProductionPlanningServices, IProductionPlanningServices } from './productionPlanning_services';
import { createStyleCategoryServices, IStyleCategoryServices } from './styleCategory_services';

export interface IServices {
  userServices: IUserServices;
  testTargetServices: ITestTargetServices;
  routingServices: IRoutingServices;
  workOrderServices: IWorkOrderServices;
  productServices: IProductServices;
  listCategoryServices: IListCategoryServices;
  commonDateServices: ICommonDateServices;
  reportServices: IReportService;
  productRoutingServices: IProductRoutingServices;
  mCCommandServices: IMCCommandServices;
  historyReceiveServices: IHistoryReceiveServices;
  reportSavedServices: IReportSavedServices;
  productionPlanningServices: IProductionPlanningServices
  styleCategoryServices: IStyleCategoryServices
}

export function createServices(): IServices {
  return {
    userServices: createUserServices(),
    testTargetServices: createTestTargetServices(),
    routingServices: createRoutingServices(),
    workOrderServices: createWorkOrderServices(),
    productServices: createProductServices(),
    listCategoryServices: createListCategoryServices(),
    commonDateServices: createCommonDateServices(),
    reportServices: createReportService(),
    productRoutingServices: createProductRoutingServices(),
    mCCommandServices: createMCCommandServices(),
    historyReceiveServices: createHistoryRecieveServices(),
    reportSavedServices: createReportSavedServices(),
    productionPlanningServices: createProductionPlanningServices(),
    styleCategoryServices: createStyleCategoryServices(),
  };
}
